define.alias("ember-tooltips/components/ember-tooltip", "media/components/ember-tooltip");